import { render } from "./ButtonContinue.vue.ts?vue&type=template&id=631bd282&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ButtonContinue.vue?vue&type=template&id=631bd282&ts=true"
import script from "./ButtonContinue.vue.ts?vue&type=script&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ButtonContinue.vue?vue&type=script&lang=ts"
export * from "./ButtonContinue.vue.ts?vue&type=script&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ButtonContinue.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/merchant3/shared-components/ui/ButtonContinue.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "631bd282"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('631bd282', __exports__)) {
    api.reload('631bd282', __exports__)
  }
  
  module.hot.accept("./ButtonContinue.vue.ts?vue&type=template&id=631bd282&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ButtonContinue.vue?vue&type=template&id=631bd282&ts=true", () => {
    api.rerender('631bd282', render)
  })

}


export default __exports__